import React, { Component, Fragment } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const getListStyle = (isDraggingOver) => ({
  display: 'flex',
  flexFlow: 'column nowrap',
});

class DndVerticalList extends Component {
  onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const { items, onChange } = this.props;
    onChange(reorder(items, result.source.index, result.destination.index));
  };

  render() {
    const { items } = this.props;

    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              style={getListStyle(snapshot.isDraggingOver)}
              {...provided.droppableProps}
            >
              {items.map((item, index) => {
                const draggableComponent = (
                  <Draggable key={item.id} draggableId={item.id} index={index}>
                    {(providedDraggable) => (
                      <div
                        ref={providedDraggable.innerRef}
                        {...providedDraggable.draggableProps}
                        {...providedDraggable.dragHandleProps}
                      >
                        {item.component}
                      </div>
                    )}
                  </Draggable>
                );

                return (
                  <Fragment key={item.id}>
                    {item.wrapperComponent ? item.wrapperComponent(draggableComponent) : draggableComponent}
                  </Fragment>
                );
              })}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  }
}

export default DndVerticalList;
